import styles from './SafeArea.module.scss'

import type { HTMLAttributes, ReactNode } from 'react'

type SafeAreaProps = {
  children: ReactNode
  style?: HTMLAttributes<HTMLDivElement>['style']
}

const SafeArea = ({ children, style }: SafeAreaProps) => {
  return (
    <div className={styles['safe-area']} style={style}>
      {children}
    </div>
  )
}

export { SafeArea }
